import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
const COMET_HOME_PATH_PREFIX = /^\/b\//;
/**
 * Returns true if the pathname is 1 of comet landing pages
 * @param pathname - The pathname to check
 * @returns true if the pathname is 1 of comet landing pages
 */
export function isCometLandingPage(pathname) {
    return pathname && COMET_HOME_PATH_PREFIX.test(pathname);
}
/**
 * Whether we're in a search page for a given slug
 * @param slug - The slug to check
 * @returns true if we're in a search page for the given slug
 */
export function isSearchPage(slug) {
    if (!slug) {
        return false;
    }
    const url = new URL(window.location.href);
    // So different bases still work
    return url.pathname.endsWith(`/search/${slug}`);
}
/**
 * Returns the path to the homepage
 * @returns the path to the homepage
 */
export function homepagePath() {
    return isMaybeIncognitoComet() ? '/b/home' : '/';
}
//# sourceMappingURL=routes.js.map